import { useQuery } from '@tanstack/react-query'
import { listNegotiationActivity } from '../services/negotiationsApi'
import type { NegotiationActivityEntry } from '../services/negotiationsApi'

export type { NegotiationActivityEntry }

/** Fetch activity log for a negotiation. */
export function useNegotiationActivity(negotiationId: number | undefined, limit = 50) {
  return useQuery<NegotiationActivityEntry[]>({
    queryKey: ['negotiation-activity', negotiationId],
    queryFn: () => listNegotiationActivity(negotiationId!, limit),
    enabled: negotiationId != null,
    staleTime: 30_000,
  })
}
